import { render } from "./GigaTable.vue?vue&type=template&id=1d9e2df0"
import script from "./GigaTable.vue?vue&type=script&lang=js"
export * from "./GigaTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fanhaipeng/code/giga-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__